<template>
    <div class="rich-html-container-parent">
        <div :class="[containerClass]" v-html="html" :key="resourceId"></div>
    </div>
</template>

<script>
    /* global LearnosityItems LearnosityReports:true */
    import { mapActions } from 'vuex'
    export default {
      name: 'rich-html-launch-assessment',
      props: ['html', 'resourceId', 'courseId', 'containerClass'],
      data: () => {
        return {
          itemsAppList: [],
          scoringObjects: {}
        }
      },

      watch: {
        resourceId (value) {
          this.reset()
          this.$emit('afterRender')
          setTimeout(() => {
            this.renderAssessment()
          }, 2500)
        }
      },

      mounted () {
        this.$emit('afterRender')
        this.$nextTick(() => {
          setTimeout(() => {
            this.renderAssessment()
            if (this.$refs.loadingModal) {
              this.$refs.loadingModal.hide()
            }
          }, 2500)
        })
      },

      methods: {
        ...mapActions([
          'loadRichHtmlAssessment',
          'startActivity',
          'launchRichHtmlAssessment',
          'updateAttempt',
          'launchRichHtmlAssessmentReport',
          'launchManuallyGradedReportWizardForUser',
          'loadCourseTopics',
          'loadCourseCompetencies'
        ]),

        reset () {
          $.each(this.itemsAppList, (i, itemsApp) => {
            if (typeof itemsApp.reset === 'function') {
              itemsApp.reset()
            }
          })
        },

        renderAssessment () {
          var startActivity = {
            'userId': localStorage.getItem('userid'),
            'entityUuid': this.resourceId
          }
          this.startActivity(startActivity)
          this.loadRichHtmlAssessment(this.resourceId).then(result => {
            if (result && result.length > 0) {
              $.each(result, (index, res) => {
                const data = JSON.parse(res)
                const attempt = data.attempt
                const assessment = data.assessment
                var itemsApp = {}
                this.initLaunchAssessment(assessment.uuid, assessment.sessionId, attempt, itemsApp)
              })
            }
          })
        },

        initLaunchAssessment (uuid, sessionId, attempt, itemsApp) {
          this.launchRichHtmlAssessment({uuid: uuid, sessionId: sessionId, courseId: this.courseId}).then(res => {
            if (res) {
              const orderId = res.orderId
              const sessionId = res.sessionId
              const externalId = res.externalId
              const signedRequest = JSON.parse(res.signedRequest)
              this.initialize(signedRequest, sessionId, externalId, orderId, attempt, itemsApp)
              setTimeout(() => {
                // Load course topics and course competencies to handle RICH HTML
                if (this.courseId) {
                  this.loadCourseTopics({uuid: this.courseId, loadDataFromServer: true})
                  this.loadCourseCompetencies({courseId: this.courseId, loadDataFromServer: true})
                }
              }, 1000)
            }
          })
        },

        initialize (signedRequest, sessionId, externalId, orderId, attempt, itemsApp) {
          itemsApp = LearnosityItems.init(signedRequest, {
            'readyListener': () => {
              if (this.isStudentLogin) {
                let parentId = externalId + '_' + orderId
                let id = 'submit-button-' + parentId
                $('#' + parentId).append('<p><button class="btn btn-primary" id="' + id + '">Submit Answer</button></p>')
                $('#' + id).css({'position': 'relative', 'z-index': '999'})
                $('#' + id).click(() => {
                  this.$refs.loadingModal.show()
                  itemsApp.submit({
                    success: () => {
                      this.update(sessionId, externalId, orderId, attempt, itemsApp, id)
                      setTimeout(() => {
                        // Load course topics and course competencies to handle RICH HTML
                        this.loadCourseTopics({uuid: this.courseId, loadDataFromServer: true})
                        this.loadCourseCompetencies({courseId: this.courseId, loadDataFromServer: true})
                      }, 2000)
                    },
                    error: (err) => {
                      console.log('Error: ', err)
                      this.$refs.loadingModal.hide()
                    }
                  })
                })
                this.disableSubmitButton(sessionId, externalId, orderId, attempt, itemsApp, id)
              }
            },
            'errorListener': (event) => {
              console.log('error: ', event)
            }
          })

          this.itemsAppList.push(itemsApp)
        },

        update (sessionId, externalId, orderId, attempt, itemsApp, id) {
          this.updateAttempt({sessionId: sessionId, externalId: externalId, isFinished: true}).then(res => {
            this.$refs.loadingModal.hide()
            if (res) {
              this.disableSubmitButton(sessionId, externalId, orderId, attempt, itemsApp, id, res.activityStatus)
            }
          })
        },

        disableSubmitButton (sessionId, externalId, orderId, attempt, itemsApp, id, activityStatus) {
          itemsApp.attemptedQuestions((attempted) => {
            if (attempted.length > 0 || activityStatus === 'Completed') {
              $('#' + id).prop('disabled', 'disabled')
              let parentId = externalId + '_' + orderId
              this.generateReport(sessionId, parentId, attempt)
            }
          })
        },

        generateReport (sessionId, parentId, attempt) {
          let reportId = 'session-detail-by-item-' + parentId
          $('#' + parentId).wrap('<div class="row report-section"></div>').wrap('<div class="question-section"></div>')
          $('<p><span class="learnosity-report" id="' + reportId + '"></span></p>')
            .appendTo($('#' + parentId).closest('.row')).wrap('<div class="answer-section"></div>')

          this.launchRichHtmlAssessmentReport({activityId: parentId, sessionId: sessionId}).then(data => {
            if (data) {
              var reportsApp = {}
              $('#' + parentId).remove()
              this.initializeReport(data, reportId, attempt, reportsApp)
            }
          })
        },

        initializeReport (data, reportId, attempt, reportsApp) {
          reportsApp = LearnosityReports.init(data, {
            'readyListener': () => {
              if (attempt && attempt.manuallyGraded) {
                this.bindReportReadyListener(reportsApp, reportId, attempt)
              }
            },
            'errorListener': (event) => {
              console.log('error: ', event)
            }
          })
        },

        bindReportReadyListener (reportsApp, reportId, attempt) {
          var itemReferences = []
          var report = reportsApp.getReport(reportId)
          report.on('ready:itemsApi', (itemsApp) => {
            itemsApp.getQuestions((questions) => {
              $.each(questions, (index, question) => {
                if ((question.metadata.valid_response_count === 0) && (question.metadata.rubric_reference !== undefined)) {
                  var reference = question.metadata.rubric_reference
                  var itemId = question.response_id + '_' + reference
                  this.scoringObjects[itemId] = question
                  itemReferences.push({'id': itemId, 'reference': reference})

                  $('<p><span class="learnosity-item" data-reference="' + itemId + '"></span>')
                    .appendTo($('#' + question.response_id)).wrap('<div class="teacher_scoring"></div>')
                }
              })
            })

            if (itemReferences.length > 0) {
              var itemsActivity = {
                'state': 'review',
                'type': 'feedback',
                'items': itemReferences,
                'rendering_type': 'inline',
                'session_id': attempt.sessionId,
                'activity_id': attempt.activityId
              }

              this.launchManuallyGradedReportWizardForUser(itemsActivity).then(data => {
                if (data) {
                  var itemsAppTeacherScoring = LearnosityItems.init(data, {
                    readyListener: () => {
                      this.generateScoreStimulus(itemsAppTeacherScoring)
                    }
                  })
                }
              })
            }
          })
        },

        generateScoreStimulus (itemsAppTeacherScoring) {
          $.each(itemsAppTeacherScoring.getItems(), (index, item) => {
            const question = this.scoringObjects[index]
            const text = 'Enter score between 0-' + ((question.validation && question.validation.max_score) ? question.validation.max_score : 1)
            const elemId = 'stimulus-' + item.response_ids[0]
            $('#' + elemId).text(text)
          })
        }

      },

      computed: {
        isStudentLogin: function () {
          return (localStorage.getItem('userrole') === 'Student')
        }
      }
    }
</script>

<style scoped>
	iframe {
		width: 90%;
		height : 100px;
	}
	img {
		width: 90%;
		height : 100px;
	}
    .rich-html-container-parent {
        height: calc(100vh - 200px);
        width: 90%;
        max-width: 86%;
        border: 0px solid #ccc;
        margin-left: 7%;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .rich-html-container {
        width: 90%;
        max-width: 90%;
        margin-left: 5%;
        margin-top: 2%;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .rich-html-container-learn {
        width: 90%;
        max-width: 90%;
        margin-left: 5%;
        margin-top: 2%;
        overflow-y: auto;
        overflow-x: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/app/assessment/components/RichHtmlLaunchAssessment.vue